module.exports = __webpack_public_path__ + "static/media/YF107_2.1cfc5e96.jpg";